import React, {forwardRef} from 'react';
import PropTypes from 'prop-types';
import Results from "components/HelpCenter/InputSearch/Results";
import style from './style.scss';//NOSONAR

const InputSearch = forwardRef((props, searchInput) => {
    const {onSubmit, goBack, clearSearch, onChange, onFocus, search, modalAutocomplete, submitted, closeModalAutocomplete, resultsProps} = props;

    return(
        <>
            <form className='input-search-header-form' onSubmit={onSubmit}>
                <button className='input-search-header-back-btn font-icn point-arrow-left' onClick={goBack} type='button' aria-label="close seach button"/>
                <input ref={searchInput} type="text" className='input-search-header' placeholder='¿Qué estás buscando?' tabIndex={1} onChange={onChange} onFocus={onFocus} value={search} aria-label="Search Bar"/>
                <button className='input-search-header-submit jumbo-icon-search' type='submit' aria-label="search button"/>
                {search && search.length > 0 && modalAutocomplete && <button className='input-search-header-clear-btn' onClick={clearSearch} type='button' aria-label="clear search button"/>}

                {!submitted && <Results {...resultsProps} />}
            </form>

            <div className={'input-search-header-overlay ' + ((modalAutocomplete && !submitted) ? 'active' : '')} onClick={closeModalAutocomplete} />
        </>
    )
})

InputSearch.propTypes = {
    onSubmit: PropTypes.func,
    goBack: PropTypes.func,
    clearSearch: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    modalAutocomplete: PropTypes.bool,
    submitted: PropTypes.bool,
    closeModalAutocomplete: PropTypes.func,
    resultsProps: PropTypes.object,
    search: PropTypes.string
}
InputSearch.displayName = 'InputSearch'
export default InputSearch;